module.exports = new __parcel__URL__("goblet.2a7d512c.webp").toString();